import React, { useState } from 'react';
import { useSelector } from 'react-redux'; 
import { useNavigate, Link } from 'react-router-dom';  
import { RootState } from '../../../store/store'; 
import { Box, Container, Typography } from '@mui/material';   
import { SignInFormStyles } from '../../../assets/css/signInForm.styles';  
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import CustomLabeledTextField from '../../../components/customTextField/customLabeledTextField';
import CustomButton from '../../../components/customButton/customButton';
import Loader from '../../../components/loader';
import { forgotPassword } from '../../../reducers/authReducer';
import themeEn from '../../../themes/index.en';
import themeAr from '../../../themes/index.ar';
import { ArrowBack } from '@mui/icons-material';  
import { useTranslation } from 'react-i18next';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { sendActionStatus } from '../../../reducers/externalApiReducer';


const ForgotPasswordForm: React.FC = () => {
  const { t }: { t: (key: string) => string } = useTranslation();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRTL = currentLanguage === 'ar'; 
  const [email, setEmail] = useState('');  
  const [touched, setTouched] = useState({ email: false });
  const authState = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value); 
  
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (email.trim() ==="") {  
        dispatch(sendActionStatus({token:'', status:false, action:'forgotPassword',message:`${t('forgotPasswordMessage')}` ,redirection:'' }));  
        return;
    }
    dispatch(forgotPassword({ email })).unwrap()  
    .then((response) => {  
        const { message,messageCode, success } = response.data;  
        if(success){ 
            dispatch(sendActionStatus({token:'', status:true, action:'forgotPassword',message:`${t(messageCode || "")}` ,redirection:'/Signin' }));  
        }
        else{
          dispatch(sendActionStatus({token:'', status:false, action:'forgotPassword',message:`${t(messageCode || "")}` ,redirection:'' }));  
        }  
    }).catch((error) => {
        console.error(error)
    }); 
  };

  return (
    <ThemeProvider theme={isRTL ? themeAr : themeEn}>
    <Container component="main" maxWidth="sm" sx={SignInFormStyles.container}> 
        {authState.isLoading && <Loader />} 
        <div> 
          <Typography variant="h5" component="h2" align="center" sx={{ marginBottom: "25px" }}>
            {t('forgotPasswordMessage')}
          </Typography>
        </div>  
        <Box component="form" onSubmit={handleSubmit} noValidate style={SignInFormStyles.form}>
          <CustomLabeledTextField
            label={t('email')}
            name="email"
            isRTL={isRTL}
            type="text"
            value={email}
            onChange={handleEmailChange}
            required={true}
            autoFocus={true} 
          />  
          <CustomButton 
            type="submit" 
            style={authState.isLoading ? SignInFormStyles.disableButton : SignInFormStyles.button}
          >
            {t('continue')}
          </CustomButton> 
        </Box>  
 
        <Typography variant="body2" align="center" sx={{ marginTop: "15px" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} />
            <Link to="/Signin" style={{ color: themeEn.palette.text.primary, fontWeight: "bold", textDecoration: "none" }}>
              {t('backSignIn')}
            </Link>
          </Box>
        </Typography> 
    </Container>
    </ThemeProvider>
  );
};

export default ForgotPasswordForm;
